import script from "./IN9-M.vue?vue&type=script&setup=true&lang=js"
export * from "./IN9-M.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__